/**
 * Navigation structure (spec section 57).
 *
 * Items whose backing route is not implemented yet are still listed. Hiding
 * them would make the tool look more complete than it is; each one leads to a
 * screen that states plainly what is missing and when it arrives.
 *
 * Labels are resolved from the dictionary at render time rather than baked in,
 * so the sidebar follows the language toggle like everything else. The routes
 * are the stable identity here; the words are not.
 */

import type { Dictionary } from '../../i18n';

export type NavItem = {
  to: string;
  label: string;
  /** Matches child routes as well, e.g. /players/:id under Members. */
  matchPrefix?: string;
};

export type NavGroup = {
  label: string | null;
  items: NavItem[];
};

export function navGroups(t: Dictionary): NavGroup[] {
  return [
    {
      label: null,
      items: [{ to: '/', label: t.nav.overview }],
    },
    {
      label: t.nav.groups.alliance,
      items: [
        { to: '/alliance/members', label: t.nav.members, matchPrefix: '/players' },
        { to: '/alliance/growth', label: t.nav.growth },
        { to: '/alliance/activity', label: t.nav.activity },
        { to: '/alliance/roles', label: t.nav.roles },
      ],
    },
    {
      label: t.nav.groups.bear,
      items: [
        { to: '/bear/me', label: t.nav.personalAnalyzer, matchPrefix: '/bear/player' },
        { to: '/bear/planner', label: t.nav.alliancePlanner },
        { to: '/bear/history', label: t.nav.bearHistory },
        { to: '/bear/experiments', label: t.nav.experiments },
      ],
    },
    {
      label: null,
      items: [{ to: '/rally', label: t.nav.rallyLab }],
    },
    {
      label: t.nav.groups.events,
      items: [
        { to: '/events/championship', label: t.nav.championship },
        { to: '/events/swordland', label: t.nav.swordland },
        { to: '/events/fortress', label: t.nav.fortress },
        { to: '/events/castle', label: t.nav.castle },
        { to: '/events/viking', label: t.nav.viking },
        { to: '/events/tri-alliance', label: t.nav.triAlliance },
        { to: '/events/mobilization', label: t.nav.mobilization },
      ],
    },
    {
      label: t.nav.groups.stateIntel,
      items: [
        { to: '/state/alliances', label: t.nav.stateAlliances },
        { to: '/state/players', label: t.nav.statePlayers },
        { to: '/state/transfers', label: t.nav.transfers },
        { to: '/state/leaderboards', label: t.nav.leaderboards },
        { to: '/state/kvk', label: t.nav.kvk },
      ],
    },
    {
      label: t.nav.groups.data,
      items: [
        { to: '/data/freshness', label: t.nav.freshness },
        { to: '/data/rules', label: t.nav.rules },
        { to: '/data/catalog', label: t.nav.catalog },
        { to: '/data/sync', label: t.nav.syncStatus },
        { to: '/data/settings', label: t.nav.settings },
      ],
    },
  ];
}
